import { getCountryCode } from './getCountryCode'

// Maps a geolocation country code to the locale used for content targeting and
// localization (e.g. Builder, the homepage categories). Anything without a
// specific mapping falls back to the default locale.
export const DEFAULT_LOCALE = 'en-US'

const COUNTRY_LOCALE = {
  KR: 'ko-KR',
  CN: 'zh-CN',
  TW: 'zh-CN',
  HK: 'zh-CN',
  MO: 'zh-CN'
}

export const localeForCountry = (countryCode) =>
  COUNTRY_LOCALE[(countryCode || '').toUpperCase()] || DEFAULT_LOCALE

export const getLocale = async () => localeForCountry(await getCountryCode())

export default getLocale
